import { Wrapper } from '../../tabs/OptionTabs/styles';

export default Wrapper;
